import { forwardRef } from 'react'

import Input from './Input'

const DateTimeInput = forwardRef((props, ref) => (
  <Input {...props} ref={ref} type='datetime-local' />
))

export default DateTimeInput
